module.exports = __webpack_public_path__ + "static/img/logo3.3b7c162.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/logo3.png
// module id = cs5C
// module chunks = 30